import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=21d198be&scoped=true"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=js"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderDetails.vue?vue&type=style&index=0&id=21d198be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d198be",
  null
  
)

export default component.exports